export * from './domain-setup-template';
